import React from 'react';

export const Banner1: React.FC = () => (
    <React.Fragment>
        <defs>
            <clipPath id="hmb1">
                <path fill="#121c45" d="M12 0h241a12 12 0 0112 12v103H0V12A12 12 0 0112 0z"
                      transform="translate(402 557)"/>
            </clipPath>
        </defs>
        <path fill="#1c2f61" d="M12 0h241c7 0 12 6 12 14v117H0V14C0 6 5 0 12 0z"/>
        <g clipPath="url(#hmb1)" transform="translate(-402 -557)">
            <g transform="translate(438 603)">
                <path fill="#fff"
                      d="M12,2a7.955,7.955,0,0,1,8,8.2q0,4.98-8,11.8Q4,15.175,4,10.2A7.955,7.955,0,0,1,12,2Zm6,8.2a6,6,0,1,0-12,0c0,2.34,1.95,5.44,6,9.14C16.05,15.64,18,12.54,18,10.2ZM12,12a2,2,0,1,1,2-2A2.006,2.006,0,0,1,12,12Z"
                      transform="translate(0 0)"/>
            </g>
            <g className="d" transform="translate(426 594)">
                <rect width="244" stroke="#0A68FF" height="41" fill="none" x="1" y="1" className="f" rx="5.5"/>
            </g>
            <text fill="#fff" className="text-base font-sans" transform="translate(474 620)">
                <tspan x="0" y="0">Anywhere, Australia</tspan>
            </text>
            <line y2="18" stroke="#0A68FF" transform="translate(635.5 605)"/>
            <g>
                <path
                    d="M610.992 640.209L589.015 620 589 649.856l6.669-6.381 3.917 8.925 6.111-2.681-3.917-8.929zm-7.8 8.539l-2.63 1.152-4.245-9.676-5.416 5.186.01-21.088 15.523 14.278-7.482.475z"
                    fill="#fff"/>
            </g>
        </g>
    </React.Fragment>
);

export const Banner2: React.FC = () => (
    <React.Fragment>
        <defs>
            <clipPath id="hmb2">
                <path fill="#121c45" d="M12 0h241a12 12 0 0112 12v103H0V12A12 12 0 0112 0z"
                      transform="translate(699 557)"/>
            </clipPath>
        </defs>
        <path fill="#1c2f61" d="M12 0h241a12 12 0 0112 12v119H0V12A12 12 0 0112 0z"/>
        <g clipPath="url(#hmb2)" transform="translate(-699 -557)">
            <g transform="translate(0 3) translate(0 -3) translate(723 637.299)">
                <line x2="324.58" fill="none" stroke="#fff" transform="translate(0.417 4.589)"/>
                <line x2="211.102" fill="none" stroke="#0a68ff" strokeWidth="2px" transform="translate(0.417 4.589)"/>
                <g className="f" transform="translate(0 -0.3)">
                    <circle cx="5" cy="5" r="5" className="fill-blue"/>
                    <circle cx="5" cy="5" r="4" className="fill-white"/>
                </g>
                <g className="f" transform="translate(206 -0.3)">
                    <circle cx="5" cy="5" r="5" className="fill-blue"/>
                    <circle cx="5" cy="5" r="4" className="fill-white"/>
                </g>
                <g className="f" transform="translate(102 -0.3)">
                    <circle cx="5" cy="5" r="5" className="fill-blue"/>
                    <circle cx="5" cy="5" r="4" className="fill-white"/>
                </g>
                <text fill="#fff" className="font-bold text-sm" transform="translate(97 23.701)">
                    <tspan x="0" y="0">5km</tspan>
                </text>
                <text fill="#fff" className="font-bold text-sm" transform="translate(0 23.701)">
                    <tspan x="0" y="0">1km</tspan>
                </text>
                <text fill="#fff" className="font-bold text-sm"
                      transform="translate(199 23.701)">
                    <tspan x="0" y="0">10km</tspan>
                </text>
            </g>
            <g className="j" transform="translate(0 3) translate(723 576)">
                <rect width="111" height="36" fill="none" stroke="#0a68ff" rx="6"/>
            </g>
            <text className="k" transform="translate(0 3) translate(735 599)">
                <tspan x="0" y="0" fill="#fff">Duration</tspan>
            </text>
            <path d="M818.59 593.59l-4.59 4.58-4.59-4.58L808 595l6 6 6-6z" fill="#0a68ff"/>
            <g className="j" transform="translate(0 3) translate(850 576)">
                <rect width="123" height="36" fill="none" stroke="#0a68ff" rx="6"/>
            </g>
            <text className="k" transform="translate(0 3) translate(862 599)">
                <tspan x="0" y="0" fill="#fff">Car model</tspan>
            </text>
            <g>
                <path d="M957.59 593.59l-4.59 4.58-4.59-4.58L947 595l6 6 6-6z" fill="#0a68ff"/>
            </g>
        </g>
    </React.Fragment>
);

export const Banner3: React.FC = () => (
    <React.Fragment>
        <defs>
            <path id="reuse-0" d="M.5 0v93M10.5 0v93M20.5 0v93M30.5 0v93M40.5 0v93" className="f"/>
        </defs>
        <defs>
            <clipPath id="hmb3a">
                <path fill="#121c45" d="M12 0h241a12 12 0 0112 12v119H0V12A12 12 0 0112 0z"
                      transform="translate(996 557)"/>
            </clipPath>
            <clipPath id="hmb3b">
                <path d="M0 0h49v93H0z"/>
            </clipPath>
            <clipPath id="hmb3c">
                <path d="M0 0h78v89H0z"/>
            </clipPath>
            <clipPath id="hmb3d">
                <path d="M0 0h49v88H0z" />
            </clipPath>
        </defs>
        <path fill="#1c2f61" d="M12 0h241a12 12 0 0112 12v119H0V12A12 12 0 0112 0z"/>
        <g clipPath="url(#hmb3a)" transform="translate(-996 -557)">
            <path d="M1020 578.4v145.356l101.537 1V596.202l-21.321-17.8z" fill="none" stroke="#0A68FF"/>
            <path d="M1100.153 578.4v17.959h21.5" fill="none" stroke="#0A68FF"/>
            <path d="M1031.5 594.5h21M1031.5 611.5h21M1031.5 602.5h5M1040.5 602.5h20" fill="none" stroke="#fff"/>
            <g>
                <path d="M1031 620h79v93h-79z" stroke="#fff" fill="none"/>
                <path d="M1031.5 620.5h78v92h-78z" stroke="#fff" fill="none"/>
            </g>
            <g clipPath="url(#hmb3b)" transform="translate(1061 620.5)">
                <use stroke="#fff" fill="#fff" href="#reuse-0"/>
            </g>
            <g>
                <path
                    d="M1031.5 620.5h78M1031.5 628.5h78M1031.5 636.5h78M1031.5 644.5h78M1031.5 652.5h78M1031.5 660.5h78M1031.5 668.5h78M1031.5 676.5h78M1031.5 684.5h78M1031.5 692.5h78M1031.5 700.5h78M1031.5 708.5h78"
                    fill="none" stroke="#fff"/>
            </g>
            <g>
                <path d="M1136 502.4v145.356l101.537 1V520.202l-21.321-17.8z" stroke="#0A68FF" fill="none" />
                <path d="M1216.153 502.4v17.959h21.5" className="fill-none" stroke="#fff" fill="none" />
                <path d="M1147.5 518.5h21M1147.5 535.5h21M1147.5 526.5h5M1156.5 526.5h20" fill="none" stroke="#fff"/>
                <g className="g">
                    <path d="M1147 544h79v89h-79z" stroke="#fff" fill="none"/>
                    <path d="M1147.5 544.5h78v88h-78z" stroke="#fff" fill="none"/>
                </g>
                <g clipPath="url(#hmb3d)" transform="translate(1177 544.5)">
                    <use stroke="#fff" href="#reuse-0"/>
                </g>
                <g>
                    <path
                        d="M1147.5 544.5h78M1147.5 552.5h78M1147.5 560.5h78M1147.5 568.5h78M1147.5 576.5h78M1147.5 584.5h78M1147.5 592.5h78M1147.5 600.5h78M1147.5 608.5h78M1147.5 616.5h78M1147.5 624.5h78M1147.5 632.5h78"
                        stroke="#fff"/>
                </g>
            </g>
        </g>
    </React.Fragment>
)

